import { ApModal } from '@alixpartners/ui-components';
import styled from 'styled-components';

export const Modal = styled(ApModal)`
  .ap-modal-header {
    position: relative;
    border-bottom: 0;
    padding: 22px 32px;

    .ap-button-icon {
      position: absolute;
      right: 14px;
      top: 14px;
    }
  }

  h4 {
    font-style: normal;
    font-weight: 500;
    font-size: 23px;
    line-height: 28px;
  }

  .ap-modal-body {
    padding: 0 32px 20px 32px;
  }
  .ap-modal-footer {
    padding: 8px 32px;
  }
`;
